import { useMemo } from "react";
import { createAvatar } from "@dicebear/core";
import { notionists } from "@dicebear/collection";

export function CustomerAvatar({ seed, size = 40, className = "", testId = "customer-face-avatar" }) {
  const src = useMemo(() => createAvatar(notionists, {
    seed: seed || "walk-in", backgroundColor: ["f8fafc"], backgroundType: ["solid"], radius: 50,
  }).toDataUri(), [seed]);
  return (
    <img src={src} alt="" width={size} height={size} data-testid={testId}
         className={`rounded-full border border-[#E5E7EB] bg-white shrink-0 ${className}`} style={{ width: size, height: size }} />
  );
}
